import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import axios from 'axios';

import { experienceKeys } from './queryKeys';
import { ITaxon } from '../taxon/interfaces';


export const getExperienceTaxons = async () => {
	return await axios
		.get<ITaxon>(`/api/v2/shop/taxons/experience`)
		.then(response => {
			return Promise.resolve(response.data);
		})
		.catch(error => {
			console.error('Error getting experience taxons: ', error);
			return Promise.reject(error);
		});
};

type UseGetTaxonsQueryOptions = UseQueryOptions<ITaxon, any, ITaxon>;

export function useGetExperienceTaxonsQuery(options?: UseGetTaxonsQueryOptions) {
	return useQuery(
		experienceKeys.taxons(),
		() => {
			return getExperienceTaxons();
		},
		options as any
	);
}
